module.exports = __webpack_public_path__ + "static/media/gpv-telehealth-service.20f0c48c.jpg";